

















































import Vue from 'vue';
import firebase, { db } from '@/plugins/firebase';
import { ITimelineEvent } from '@/types';
import { Prop, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import Dialog from '@/store/modules/dialog';

@Component({})
export default class TaggingEvent extends Vue {
  @Prop(Object) event!: ITimelineEvent;
  user = {};
  entry: any = { likes: {} };
  authModule = getModule(Auth, this.$store);

  get tags() {
    return this.event.data.text.split(' ');
  }

  async created() {
    this.user = await this.$db.getUserData(this.event.data.uid);
    this.entry = await this.$db.getEntryData(this.event.data.entryId);
  }
}
